export class ProductCategory {
  public id: string;
  public name: string;
  public isActive: string;

  constructor (
    id = '',
    name = '',
    isActive = ''
  ) {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/product-category.ts